import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DateFormat, TimeFormat } from "../types/dateTimeFormats";

export type DateTimeFormatsSlice = {
  loading: boolean;
  dateFormats: DateFormat[];
  timeFormats: TimeFormat[];
};

const initialState: DateTimeFormatsSlice = {
  loading: false,
  dateFormats: [],
  timeFormats: []
};

const dateTimeFormatsSlice = createSlice({
  name: "dateTimeFormats",
  initialState,
  reducers: {
    startGetDateFormats(state) {
      state.loading = true;
      state.dateFormats = [];
    },
    getDateFormatsSuccess(state, action: PayloadAction<DateFormat[]>) {
      state.dateFormats = action.payload;
      state.loading = false;
    },
    getDateFormatsFailure(state) {
      state.loading = false;
      state.dateFormats = [];
    },
    startGetTimeFormats(state) {
      state.loading = true;
      state.timeFormats = [];
    },
    getTimeFormatsSuccess(state, action: PayloadAction<TimeFormat[]>) {
      state.timeFormats = action.payload;
      state.loading = false;
    },
    getTimeFormatsFailure(state) {
      state.loading = false;
      state.timeFormats = [];
    }
  }
});

export const {
  startGetDateFormats,
  getDateFormatsSuccess,
  getDateFormatsFailure,
  startGetTimeFormats,
  getTimeFormatsSuccess,
  getTimeFormatsFailure
} = dateTimeFormatsSlice.actions;

export default dateTimeFormatsSlice.reducer;
